import GuestMenu from './GuestMenu'

export default GuestMenu
